module.exports = __webpack_public_path__ + "static/media/logo_footer.84a35e40.png";